//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.api

import com.tixforgigs.apax.models.AccountTicket
import com.tixforgigs.apax.models.ApiError
import com.tixforgigs.apax.models.CreateResaleRequest
import com.tixforgigs.apax.models.ResaleConfig
import com.tixforgigs.apax.models.ShopEvent

import com.tixforgigs.apax.infrastructure.*
import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig
import io.ktor.client.request.forms.formData
import io.ktor.client.engine.HttpClientEngine
import kotlinx.serialization.json.Json
import io.ktor.http.ParametersBuilder
import kotlinx.serialization.*
import kotlinx.serialization.descriptors.*
import kotlinx.serialization.encoding.*

open class CommonTicketsApi : ApiClient {

    constructor(
        baseUrl: String = ApiClient.BASE_URL,
        httpClientEngine: HttpClientEngine? = null,
        httpClientConfig: ((HttpClientConfig<*>) -> Unit)? = null,
        jsonSerializer: Json = ApiClient.JSON_DEFAULT
    ) : super(baseUrl = baseUrl, httpClientEngine = httpClientEngine, httpClientConfig = httpClientConfig, jsonBlock = jsonSerializer)

    constructor(
        baseUrl: String,
        httpClient: HttpClient
    ): super(baseUrl = baseUrl, httpClient = httpClient)

    /**
     * Get tickets, with optional filtering (version from:4.6 to:latest)
     * Get events/tickets for current user, may be filtered by event, contingent, location and/or promoter, tickets are searched 60 days back in time. Also includes tickets in a pending transfer state, that can be accepted by the current user. Pending transfer tickets were not filtered here, always includes all pending ticket for the current user.
     * @param eventId the eventId for filtering (optional)
     * @param contingentId the contingentId for filtering (optional)
     * @param venueId the venueId for filtering (optional)
     * @param promoterId the promoterId user for filtering (optional)
     * @param dbVersion Defines a db version to sync only a diff since this version. (optional, default to 0L)
     * @param page Zero-based page index (0..N) (optional, default to 0)
     * @param size The size of the page to be returned (optional, default to 24)
     * @param sort Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. (optional)
     * @return kotlin.collections.List<AccountTicket>
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun ticketAll(eventId: kotlin.Int? = null, contingentId: kotlin.Int? = null, venueId: kotlin.Int? = null, promoterId: kotlin.String? = null, dbVersion: kotlin.Long? = 0L, page: kotlin.Int? = 0, size: kotlin.Int? = 24, sort: kotlin.collections.List<kotlin.String>? = null): HttpResponse<kotlin.collections.List<AccountTicket>> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        eventId?.apply { localVariableQuery["eventId"] = listOf("$eventId") }
        contingentId?.apply { localVariableQuery["contingentId"] = listOf("$contingentId") }
        venueId?.apply { localVariableQuery["venueId"] = listOf("$venueId") }
        promoterId?.apply { localVariableQuery["promoterId"] = listOf("$promoterId") }
        dbVersion?.apply { localVariableQuery["dbVersion"] = listOf("$dbVersion") }
        page?.apply { localVariableQuery["page"] = listOf("$page") }
        size?.apply { localVariableQuery["size"] = listOf("$size") }
        sort?.apply { localVariableQuery["sort"] = toMultiValue(this, "multi") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/tickets",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap<TicketAllResponse>().map { value }
    }

    @Serializable(TicketAllResponse.Companion::class)
    private class TicketAllResponse(val value: List<AccountTicket>) {
        companion object : KSerializer<TicketAllResponse> {
            private val serializer: KSerializer<List<AccountTicket>> = serializer<List<AccountTicket>>()
            override val descriptor = serializer.descriptor
            override fun serialize(encoder: Encoder, value: TicketAllResponse) = serializer.serialize(encoder, value.value)
            override fun deserialize(decoder: Decoder) = TicketAllResponse(serializer.deserialize(decoder))
        }
    }

    /**
     * Gets a ticket by id (version from:4.6 to:latest)
     * get the data for a specific ticket
     * @param ticketId the ticketId
     * @param hash hash, enabling anonymous access to a specific ticket (optional)
     * @return AccountTicket
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun ticketDetails(ticketId: kotlin.Int, hash: kotlin.String? = null): HttpResponse<AccountTicket> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        hash?.apply { localVariableQuery["hash"] = listOf("$hash") }
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/tickets/{ticketId}".replace("{" + "ticketId" + "}", "$ticketId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Cancel the ticket resale. (version from:4.6 to:latest)
     * 
     * @param resaleId the ticketResaleId
     * @return void
     */
    open suspend fun ticketResaleCancel(resaleId: kotlin.Int): HttpResponse<Unit> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.DELETE,
            "/tickets/resale/{resaleId}".replace("{" + "resaleId" + "}", "$resaleId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * If configured and resale possible for contingent, gets the config for resale-creation (version from:4.6 to:latest)
     * 
     * @param ticketId the ticketId
     * @return ResaleConfig
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun ticketResaleConfig(ticketId: kotlin.Int): HttpResponse<ResaleConfig> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/tickets/resale/config/{ticketId}".replace("{" + "ticketId" + "}", "$ticketId"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


    /**
     * Creates a ticket-resale. (version from:4.6 to:latest)
     * 
     * @param createResaleRequest 
     * @return void
     */
    open suspend fun ticketResaleCreate(createResaleRequest: CreateResaleRequest): HttpResponse<Unit> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = createResaleRequest

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.POST,
            "/tickets/resale",
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return jsonRequest(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }



    /**
     * If configured and resale possible for contingent, gets the config for resale-creation (version from:4.6 to:latest)
     * 
     * @param resaleToken the resaleToken
     * @return ShopEvent
     */
    @Suppress("UNCHECKED_CAST")
    open suspend fun ticketResaleDirectInfo(resaleToken: kotlin.String): HttpResponse<ShopEvent> {

        val localVariableAuthNames = listOf<String>()

        val localVariableBody = 
            io.ktor.client.utils.EmptyContent

        val localVariableQuery = mutableMapOf<String, List<String>>()
        val localVariableHeaders = mutableMapOf<String, String>()

        val localVariableConfig = RequestConfig<kotlin.Any?>(
            RequestMethod.GET,
            "/tickets/resale/direct/{resaleToken}".replace("{" + "resaleToken" + "}", "$resaleToken"),
            query = localVariableQuery,
            headers = localVariableHeaders,
            requiresAuthentication = false,
        )

        return request(
            localVariableConfig,
            localVariableBody,
            localVariableAuthNames
        ).wrap()
    }


}
